import React from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram, Youtube, Linkedin } from 'lucide-react';
import { contactInfo } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-[#0B1430] text-white pt-16 pb-8">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-4 gap-10">
        {/* Brand */}
        <div>
          <div className="mb-4">
            <img
              src="/logo.png"
              alt="Future Smarter Lighting"
              className="h-24 w-auto object-contain drop-shadow-[0_0_20px_rgba(212,168,83,0.3)]"
            />
          </div>
          <p className="text-white/70 text-[13px] leading-relaxed">
            We bring intelligence, convenience and efficiency to your home with advanced lighting automation solutions.
          </p>
        </div>

        {/* Quick links */}
        <div>
          <h4 className="font-semibold mb-4">Quick Links</h4>
          <ul className="space-y-2 text-[13px] text-white/70">
            <li><a href="#home" className="hover:text-[#D4A853] transition-colors">Home</a></li>
            <li><a href="#about" className="hover:text-[#D4A853] transition-colors">About Us</a></li>
            <li><a href="#how-it-works" className="hover:text-[#D4A853] transition-colors">How It Works</a></li>
            <li><a href="#features" className="hover:text-[#D4A853] transition-colors">Features</a></li>
            <li><a href="#projects" className="hover:text-[#D4A853] transition-colors">Projects</a></li>
          </ul>
        </div>

        {/* Secondary */}
        <div>
          <h4 className="font-semibold mb-4 invisible">More</h4>
          <ul className="space-y-2 text-[13px] text-white/70">
            <li><a href="#testimonials" className="hover:text-[#D4A853] transition-colors">Testimonials</a></li>
            <li><a href="#faqs" className="hover:text-[#D4A853] transition-colors">FAQs</a></li>
            <li><a href="#contact" className="hover:text-[#D4A853] transition-colors">Contact Us</a></li>
            <li><a href="#" className="hover:text-[#D4A853] transition-colors">Privacy Policy</a></li>
            <li><a href="#" className="hover:text-[#D4A853] transition-colors">Terms &amp; Conditions</a></li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="font-semibold mb-4">Contact Us</h4>
          <ul className="space-y-3 text-[13px] text-white/70">
            <li className="flex items-center gap-2"><Phone size={15} className="text-[#D4A853] shrink-0" /> {contactInfo.phone}</li>
            <li className="flex items-center gap-2"><Mail size={15} className="text-[#D4A853] shrink-0" /> {contactInfo.email}</li>
            <li className="flex items-start gap-2"><MapPin size={15} className="text-[#D4A853] shrink-0 mt-0.5" /> <span className="leading-snug">{contactInfo.address}</span></li>
          </ul>
          <h4 className="font-semibold mt-6 mb-3">Follow Us</h4>
          <div className="flex gap-3">
            {[Facebook, Instagram, Youtube, Linkedin].map((Icon, i) => (
              <a key={i} href="#" className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#D4A853] hover:text-[#0B1430] flex items-center justify-center transition-colors">
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 mt-10 pt-6 border-t border-white/10 text-white/50 text-xs flex flex-col md:flex-row items-center justify-between gap-2">
        <div>© {new Date().getFullYear()} Future Smarter Lighting. All rights reserved.</div>
        <div>Made with care in Bengaluru</div>
      </div>
    </footer>
  );
};

export default Footer;
